import React from "react";
import { Form, Table, OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clearDownloadMinistryStateAction } from "../../../actions/dowloadExcelActions";
import { remove } from "lodash";
import { get } from "lodash";
import { isValidArray } from "../../../helper";
import NoDataFound from "../../../component/NoDataFound";
import request from "../../../services/requestService";
import {
  getDownloadMinistryCompliance,
  downloadMISProjectSummaryAll,
  getMinistryForCompliance,
  downloadExcel,
  getMinistryForComplianceForNonPrivate,
  getMinistryForCompliancePragati
} from "../../../services/apiServices";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { LoaderPage } from "../../../component/Loader";
import ZIPicon from "../../../assets/zip-icon.svg";
export class MinistryComplianceComponent extends React.Component {
  state = {
    minisitryIds: [],
    isLoading: false,
    downloadIcon: false,
    downloadReport: "",
    downloadIds: [],
    downloadProgress: false,
    downloadurl: [],
    ministryComplianceData: [],
    hasRendered: false,
    loading: true,
    allMinistryIds: [],
    allreportLoading: false,
    allReportDownloadZip: "",
    downloadIconallreport: false,
    allprojectradiobutton: true,
    publicprojectsradiobutton: false,
    pragatiProjectsRadio: false
  };
  handlecheckbox = value => {
    if (value == "Non_Private") {
      this.setState(
        {
          publicprojectsradiobutton: true,
          pragatiProjectsRadio: false,
          allprojectradiobutton: false,
          allreportLoading: false,
          downloadIconallreport: false,
          loading: true,
          ministryComplianceData: [],
          minisitryIds: [],
          downloadIcon: false,
          downloadIds: []
        },
        () => {
          this.getMinistryDataForNonPrivate();
        }
      );
    } else if (value == "All_Projects") {
      this.setState(
        {
          publicprojectsradiobutton: false,
          pragatiProjectsRadio: false,
          allprojectradiobutton: true,
          loading: true,
          ministryComplianceData: [],
          minisitryIds: [],
          allreportLoading: false,
          downloadIconallreport: false,
          downloadIcon: false,
          downloadIds: []
        },
        () => {
          this.getMinistryData();
        }
      );
    } else {
      this.setState(
        {
          publicprojectsradiobutton: false,
          allprojectradiobutton: false,
          pragatiProjectsRadio: true,
          loading: true,
          ministryComplianceData: [],
          minisitryIds: [],
          allreportLoading: false,
          downloadIconallreport: false,
          downloadIcon: false,
          downloadIds: []
        },
        () => {
          this.getMinistryDataForPRAGATI();
        }
      );
    }
  };
  getMinistryDataForNonPrivate = async () => {
    const response = await request(getMinistryForComplianceForNonPrivate());
    const extractedIds = response.data.data.map(item => item.id);
    this.setState({
      ministryComplianceData: response.data,
      loading: false,
      allMinistryIds: extractedIds
    });
  };
  getMinistryDataForPRAGATI = async () => {
    const response = await request(getMinistryForCompliancePragati());
    const extractedIds = response.data.data.map(item => item.id);
    this.setState({
      ministryComplianceData: response.data,
      loading: false,
      allMinistryIds: extractedIds
    });
  };
  getMinistryData = async () => {
    const response = await request(getMinistryForCompliance());
    const extractedIds = response.data.data.map(item => item.id);
    this.setState({
      ministryComplianceData: response.data,
      loading: false,
      allMinistryIds: extractedIds
    });
  };
  downloadAllMinistriesReport = async () => {
    this.setState({
      allreportLoading: true
    });
    let payload = {
      groupIds: this.state.allMinistryIds,
      implementationMode: "ALL PROJECTS"
    };
    const response = await request(downloadMISProjectSummaryAll(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 10000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.publicprojectsradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState({
              allReportDownloadZip: downloadResponse.data.data.url,
              allreportLoading: false,
              downloadIconallreport: true
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  downloadPublicProjectsReport = async () => {
    this.setState({
      allreportLoading: true
    });
    let payload = {
      groupIds: this.state.allMinistryIds,
      implementationMode: "NON PRIVATE"
    };
    const response = await request(downloadMISProjectSummaryAll(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 10000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.allprojectradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState({
              allReportDownloadZip: downloadResponse.data.data.url,
              allreportLoading: false,
              downloadIconallreport: true
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  downloadPRAGATIProjectsReport = async () => {
    this.setState({
      allreportLoading: true
    });
    let payload = {
      groupIds: this.state.allMinistryIds,
      implementationMode: "PRAGATI"
    };
    const response = await request(downloadMISProjectSummaryAll(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 10000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.allprojectradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState({
              allReportDownloadZip: downloadResponse.data.data.url,
              allreportLoading: false,
              downloadIconallreport: true
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  onDownloadAllProjects = async (id, index) => {
    const uniqueArray = [...new Set(this.state.downloadIds)];
    this.setState({
      isLoading: true,
      minisitryIds: this.state.minisitryIds.concat(id),
      downloadProgress: true,
      downloadIds: uniqueArray
    });
    let payload = {
      groupId: id,
      implementationMode: "ALL PROJECTS"
    };
    const response = await request(getDownloadMinistryCompliance(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 1000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.publicprojectsradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState(prevState => {
              const updatedMinisitryIds = prevState.minisitryIds.filter(
                val => val !== id
              );
              const updatedDownloadIds = prevState.downloadIds.includes(id)
                ? prevState.downloadIds
                : prevState.downloadIds.concat(id);
              const updatedDownloadUrls = [
                ...prevState.downloadurl,
                { id: id, url: downloadResponse.data.data.url }
              ];
              return {
                minisitryIds: updatedMinisitryIds,
                downloadIcon: true,
                downloadurl: updatedDownloadUrls,
                downloadIds: updatedDownloadIds,
                downloadProgress: false
              };
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  onDownloadPublicProjects = async (id, index) => {
    const uniqueArray = [...new Set(this.state.downloadIds)];
    this.setState({
      isLoading: true,
      minisitryIds: this.state.minisitryIds.concat(id),
      downloadProgress: true,
      downloadIds: uniqueArray
    });
    let payload = {
      groupId: id,
      implementationMode: "NON PRIVATE"
    };
    const response = await request(getDownloadMinistryCompliance(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 1000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.allprojectradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState(prevState => {
              const updatedMinisitryIds = prevState.minisitryIds.filter(
                val => val !== id
              );
              const updatedDownloadIds = prevState.downloadIds.includes(id)
                ? prevState.downloadIds
                : prevState.downloadIds.concat(id);
              const updatedDownloadUrls = [
                ...prevState.downloadurl,
                { id: id, url: downloadResponse.data.data.url }
              ];
              return {
                minisitryIds: updatedMinisitryIds,
                downloadIcon: true,
                downloadurl: updatedDownloadUrls,
                downloadIds: updatedDownloadIds,
                downloadProgress: false
              };
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  onDownloadPRAGATIProjects = async (id, index) => {
    const uniqueArray = [...new Set(this.state.downloadIds)];
    this.setState({
      isLoading: true,
      minisitryIds: this.state.minisitryIds.concat(id),
      downloadProgress: true,
      downloadIds: uniqueArray
    });
    let payload = {
      groupId: id,
      implementationMode: "PRAGATI"
    };
    const response = await request(getDownloadMinistryCompliance(payload));
    if (response.data.data) {
      let downloadStatus = false;
      let retryCount = 0;
      const maxRetries = 1000;
      const retryDelay = 2000;
      while (
        !downloadStatus &&
        retryCount < maxRetries &&
        !this.state.allprojectradiobutton &&
        !this.state.publicprojectsradiobutton
      ) {
        try {
          const downloadResponse = await request(
            downloadExcel({ key: response.data.data })
          );
          // Assuming your downloadExcel API returns a 'status' field
          if (downloadResponse.data.status === true) {
            downloadStatus = true;
            this.setState(prevState => {
              const updatedMinisitryIds = prevState.minisitryIds.filter(
                val => val !== id
              );
              const updatedDownloadIds = prevState.downloadIds.includes(id)
                ? prevState.downloadIds
                : prevState.downloadIds.concat(id);
              const updatedDownloadUrls = [
                ...prevState.downloadurl,
                { id: id, url: downloadResponse.data.data.url }
              ];
              return {
                minisitryIds: updatedMinisitryIds,
                downloadIcon: true,
                downloadurl: updatedDownloadUrls,
                downloadIds: updatedDownloadIds,
                downloadProgress: false
              };
            });
            break; // Exit the loop if download is successful
          } else {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, retryDelay));
          } else {
            console.error("Maximum download retries reached. Download failed.");
            break; // Exit the loop after maximum retries
          }
        }
      }
    }
  };
  onChangeDownloadOnlyIssueDetails = index => {
    let { downloadOnlyIssueDetails } = this.state;
    if (downloadOnlyIssueDetails.includes(index)) {
      let array = downloadOnlyIssueDetails;
      remove(array, function(e) {
        return e === index;
      });
      this.setState({ downloadOnlyIssueDetails: array });
    } else {
      this.setState(prevState => ({
        downloadOnlyIssueDetails: [...prevState.downloadOnlyIssueDetails, index]
      }));
    }
  };

  removeDuplicatesBasedOnFirstArray(arr1, arr2) {
    const uniqueIds = new Set(arr1);
    const result = [];
    const seenIdsInSecondArray = new Set();

    for (const obj of arr2) {
      if (uniqueIds.has(obj.id) && !seenIdsInSecondArray.has(obj.id)) {
        result.push(obj);
        seenIdsInSecondArray.add(obj.id);
      }
    }
    return result;
  }
  getUrlById(array, targetId) {
    for (const obj of array) {
      if (obj.id === targetId) {
        return (window.location.href = obj.url);
      }
    }
    return null; // Return null if no matching id is found
  }
  hideonDownloadReport = () => {
    window.location.href = this.state.allReportDownloadZip;
    this.setState({ downloadIconallreport: false, allReportDownloadZip: "" });
  };
  hideonDownload = id => {
    const uniqueArray = [...new Set(this.state.downloadIds)];
    this.setState({ downloadIds: uniqueArray });
    const result = this.removeDuplicatesBasedOnFirstArray(
      this.state.downloadIds,
      this.state.downloadurl
    );
    this.getUrlById(result, id);
    this.setState(
      prevState => {
        return {
          downloadIds: this.state.downloadIds.filter(val => val !== id),
          downloadReport: ""
        };
      },
      () => {}
    );
  };
  render() {
    //
    const {
      state: {
        ministryComplianceData,
        loading,
        allreportLoading,
        downloadIconallreport,
        allprojectradiobutton,
        publicprojectsradiobutton,
        pragatiProjectsRadio
      }
    } = this;
    if (!this.state.hasRendered) {
      this.setState({ hasRendered: true }, () => {
        this.getMinistryData(); // Potentially calls an API
      });
    }
    return (
      <>
        <LoaderPage loading={loading} />
        <div class="mis-header" style={{ marginBottom: 5 }}>
          <div class="d-flex align-items-center issue-main-container">
            <h3 class="m-0 issue-main-title">Ministry Data Compliance</h3>
            <span>
              {isValidArray(get(ministryComplianceData, "data")) &&
              ministryComplianceData.data != undefined ? (
                <>({ministryComplianceData.data.length})</>
              ) : (
                <>(0)</>
              )}
            </span>
            <br />
            <div className="ministry-data-radiobutton">
              <div
                class="d-flex"
                onClick={() => this.handlecheckbox("All_Projects")}
              >
                <input
                  type="radio"
                  name="All_Projects"
                  value="All_Projects"
                  checked={allprojectradiobutton}
                />
                <div class="ministry-radio-buttontext ml-2 mr-5">
                  All Projects
                </div>
              </div>
              <div
                class="d-flex"
                onClick={() => this.handlecheckbox("Non_Private")}
              >
                <input
                  type="radio"
                  name="Non_Private"
                  value="Non_Private"
                  checked={publicprojectsradiobutton}
                />
                <div class="ministry-radio-buttontext ml-2 mr-5">
                  Public Projects
                </div>
              </div>
              <div
                class="d-flex"
                onClick={() => this.handlecheckbox("Pragati_Projects")}
              >
                <input
                  type="radio"
                  name="Pragati_Projects"
                  value="Pragati_Projects"
                  checked={pragatiProjectsRadio}
                />
                <div class="ministry-radio-buttontext ml-2">
                  PRAGATI Projects
                </div>
              </div>
            </div>
          </div>

          <div class="issue-list-exposed-filters search-in-user p-0" />
          <div>
            {allreportLoading ? (
              <>
                <div className="loader-download-button">
                  <span className="download-ministries-component">
                    <span className="download-icon-ministries ministries-download-icon">
                      <Image src={ZIPicon} className="zip-icon-opacity" />
                    </span>
                    <span className="download-icon-ministries ministries-download-icon">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                  <span className="download-button__text--background">
                    Download All
                  </span>
                </div>
              </>
            ) : null}
            {!allreportLoading && !downloadIconallreport ? (
              <div
                className="download-ministries-allreportbtn"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  publicprojectsradiobutton
                    ? this.downloadPublicProjectsReport()
                    : allprojectradiobutton
                    ? this.downloadAllMinistriesReport()
                    : this.downloadPRAGATIProjectsReport()
                }
              >
                <span className="download-ministries-component">
                  <span className="download-icon-ministries ministries-download-icon">
                    <Image src={ZIPicon} className="zip-icon" />
                  </span>
                </span>
                <span className="ministries-download-text">Download All</span>
              </div>
            ) : null}
            {downloadIconallreport ? (
              <>
                <div
                  className="download-ministries-allreportbtn"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.hideonDownloadReport()}
                >
                  <span className="download-ministries-component">
                    <span className="download-icon-ministries ministries-download-icon">
                      <a className="download-img" style={{ cursor: "pointer" }}>
                        <FontAwesomeIcon
                          icon={faDownload}
                          onClick={() => this.hideonDownloadReport()}
                        />
                      </a>
                    </span>
                  </span>
                  <span className="ministries-download-text">Download All</span>
                </div>
              </>
            ) : null}
          </div>
        </div>

        <Table striped size="sm" className="mis-project-list table-striped">
          <thead>
            <tr>
              <th className="ministrycompliance-name-column">
                Sponsoring Ministry
              </th>
              <th className="ministry-cost-column">Attachments</th>
            </tr>
          </thead>
          <tbody>
            {isValidArray(get(ministryComplianceData, "data")) &&
            ministryComplianceData.data != undefined ? (
              <>
                {ministryComplianceData &&
                  ministryComplianceData.data &&
                  ministryComplianceData.data.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td className="ministry-name-column">{data.name}</td>
                        <td className="ministry-attachment-column">
                          <div className="report-only-download-box visible">
                            <span class="download-excel-component  ">
                              {this.state.minisitryIds.includes(
                                data.id
                              ) ? null : (
                                <>
                                  {this.state.downloadIcon ? null : (
                                    <span class="download-mis-file download-icon ">
                                      <span
                                        class="download-icons-excel-ministry"
                                        onClick={() =>
                                          publicprojectsradiobutton
                                            ? this.onDownloadPublicProjects(
                                                data.id
                                              )
                                            : allprojectradiobutton
                                            ? this.onDownloadAllProjects(
                                                data.id
                                              )
                                            : this.onDownloadPRAGATIProjects(
                                                data.id
                                              )
                                        }
                                      />
                                    </span>
                                  )}
                                </>
                              )}
                              {!this.state.downloadIds.includes(data.id) &&
                              this.state.downloadIcon &&
                              !this.state.minisitryIds.includes(data.id) ? (
                                <span class="download-mis-file download-icon ">
                                  <span
                                    class="download-icons-excel-ministry"
                                    onClick={() =>
                                      // publicprojectsradiobutton
                                      //   ? this.onDownloadPublicProjects(data.id)
                                      //   : this.onDownloadAllProjects(data.id)
                                      publicprojectsradiobutton
                                        ? this.onDownloadPublicProjects(data.id)
                                        : allprojectradiobutton
                                        ? this.onDownloadAllProjects(data.id)
                                        : this.onDownloadPRAGATIProjects(
                                            data.id
                                          )
                                    }
                                  />
                                </span>
                              ) : (
                                <></>
                              )}
                              {this.state.minisitryIds.includes(data.id) ? (
                                <>
                                  <span className="download-icon downloading">
                                    <span class="excel-icon" />
                                    <span className="download-icons-excel-state" />
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </>
                              ) : null}
                              {this.state.downloadIds.includes(data.id) ? (
                                <span className="download-icon agenda-download-ppt-icon">
                                  <a
                                    className="download-img"
                                    download={"Abcde.xls"}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <FontAwesomeIcon
                                      onClick={() =>
                                        this.hideonDownload(data.id)
                                      }
                                      icon={faDownload}
                                      size="2x"
                                    />
                                  </a>
                                </span>
                              ) : null}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </>
            ) : (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    // ministryStateReducer: state.donwloadExcelReducer.ministryState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      //getDownloadMinistryCompliance,
      clearDownloadMinistryStateAction
    },
    dispatch
  );
}

const MinistryCompliance = connect(
  mapStateToProps,
  mapDispatchToProps
)(MinistryComplianceComponent);
export default MinistryCompliance;
